console.log('[KLAVIYO ANALYTICS] Klaviyo analytics helper loaded');

export function trackEvent(eventName, eventData = {}) {
    //console.debug('[KLAVIYO ANALYTICS] trackEvent', { eventName, eventData });

    if (window.klaviyo?.track) {
        return window.klaviyo.track(eventName, eventData);
    } else {
        console.warn('[KLAVIYO ANALYTICS] Klaviyo is not loaded, would have tracked:', {
            eventName,
            eventData
        });
    }
}

// Event listener for collection page events
function initCollectionPageTracking() {
    if (document.body.classList.contains('template-collection')) {
        console.log('[CUSTOM] Collection page detected');

        // Track collection page view
        trackEvent('[CUSTOM] Collection Page Viewed', {
            collection_url: window.location.pathname,
            collection_name: document.title
        });
    }
}

// Event listener for cart additions
function initCartTrackingListeners() {
    // Listen for the custom cart:item-added event
    document.addEventListener('cart:item-added', function (evt) {
        console.log('[CUSTOM] Item added to cart');

        const product = evt.detail.product;

        trackEvent('[CUSTOM] Added to Cart', {
            product_id: product.id,
            product_title: product.title || product.product_title,
            variant_id: product.variant_id,
            price: product.price,
            quantity: product.quantity || 1,
            collection_context: document.body.classList.contains('template-collection')
        });
    });
}

// Initialize tracking when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initCollectionPageTracking();
        initCartTrackingListeners();
    });
} else {
    // DOM is already ready
    initCollectionPageTracking();
    initCartTrackingListeners();
}
